import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadStageService {

  constructor(private ws: PostmethodService) { }

  leadStageCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "leadStagesMaster");
  }

  roleCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "roleMaster");
  }
}
